var tabTitle = document.querySelectorAll(".c-tabs__title");
var tabBody = document.querySelectorAll(".c-tabs__body");
var clearShowed = () => {
	tabBody.forEach((tab) => {
		tab.classList.remove("showed");
	});
};
var clearActive = () => {
	tabTitle.forEach((tab) => {
		tab.classList.remove("active");
	});
};

var activeTab = () => {
	tabTitle.forEach((tab, index) => {
		tab.addEventListener("click", () => {
			clearActive();
			clearShowed();
			tab.classList.add("active");
			tabBody[index].classList.add("showed");
		});
	});
};
activeTab();